import { Reducer, Action } from "redux";
import { CustomerSettingsState, KnownOrderPadAction, unloadedCustomerSettingsState } from ".";

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

export const reducer: Reducer<CustomerSettingsState> = (state: CustomerSettingsState | undefined, incomingAction: Action): CustomerSettingsState => {
  if (state === undefined) {
    return unloadedCustomerSettingsState;
  }

  const action = incomingAction as KnownOrderPadAction;
  switch (action.type) {
    case "SET_CUSTOMER_SETTINGS":
      return {
        settings: action.settings,
      }
  }

  return state;
};
